import { Grid2, LinearProgress } from "@mui/material";
import ExistingStyle from "../ExistingAddon/ExistingStyle.module.scss";
const ExistingAddon = ({
  addon,
  existingAddons,
  totalAddons,
  onView,
  index,
  wafSites,
  stgSites,
  pfSites,
}) => {
  const progressPercentage = Math.min(
    (existingAddons / totalAddons) * 100,
    100
  );

  return addon ? (
    <>
      <Grid2 className={ExistingStyle.mainContainer}>
        {wafSites?.length !== 0 &&
        stgSites?.length !== 0 &&
        pfSites?.length !== 0
          ? index !== 0 && index !== 3 && <hr className={ExistingStyle.line} />
          : index !== 0 && <hr className={ExistingStyle.line} />}
        <Grid2 className={ExistingStyle.container}>
          <Grid2 className={ExistingStyle.headers}>
            <Grid2 className={ExistingStyle.Addonheader}>
              <Grid2>{addon.icon}</Grid2>
              <Grid2>{addon.addonType}</Grid2>
            </Grid2>
            <Grid2 className={ExistingStyle.manage} onClick={onView}>
              View
            </Grid2>
          </Grid2>
          <Grid2 className={ExistingStyle.AddonCount}>
            <span className={ExistingStyle.existingCount}>
              {existingAddons}
            </span>
            <span className={ExistingStyle.existingText}>
              / {totalAddons}{" "}
              {addon.addonType === "Staging"
                ? "Hours are used"
                : "Sites are used"}
            </span>
          </Grid2>
          <Grid2>
            <LinearProgress
              variant="determinate"
              value={progressPercentage}
              sx={{
                width: "100%",
                height: "10px",
                borderRadius: "5px",
                backgroundColor: "#f0f3f8",
              }}
            />
          </Grid2>
        </Grid2>
      </Grid2>
    </>
  ) : (
    <Grid2>No addons</Grid2>
  );
};

export default ExistingAddon;
